import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

//Create CA dependencies
import MyTooltip from '../common/MyTooltip';
import ListControlAccount from './ListControlAccount';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_VIEWER,
  STATUS_PROJECT_PUBLISHED
} from '../common/redux/constantes';

import CreateCaModel from './CreateCaModel';

export class ControlAccount extends Component {


  state = {
    openCreateCaDialog:false,
    createCaDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    caEdit:{}
  }



  closeCreateCaDialog = ()=>
  {
    this.setState({openCreateCaDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateCaDialog = ()=>{
    this.setState({
      openCreateCaDialog:true, 
      createCaDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      caEdit:{}
    });
  }

  editCa = (ca)=>{
     this.setState({
      openCreateCaDialog:true, 
      createCaDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      caEdit:ca
    });
  }

  showCa = (ca)=>{
     this.setState({
      openCreateCaDialog:true, 
      createCaDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      caEdit:ca
    });
  }

  static propTypes = {
    ca: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="ca-control-account">
        <ListControlAccount 
          project={this.props.project}
          project_status={this.props.project_status}
          ref={instance => { this.list = instance; }} editCa={this.editCa} showCa={this.showCa}/>
        <CreateCaModel 
          openDialog={this.state.openCreateCaDialog} 
          closeDialog={this.closeCreateCaDialog} 
          actionDialog={this.state.createCaDialogAction}
          caEdit={this.state.caEdit}
          project={this.props.project}
        />
            {
              Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.project_status !== STATUS_PROJECT_PUBLISHED?
              (<MyTooltip openDialog={this.openCreateCaDialog} />)
              :null
            }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    ca: state.ca,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ControlAccount);



// WEBPACK FOOTER //
// ./src/features/ca/ControlAccount.js